export const PROFESSIONAL_REFERENCE_LOADING = "PROFESSIONAL_REFERENCE_LOADING";
export const PROFESSIONAL_REFERENCE_SUCCESS = "PROFESSIONAL_REFERENCE_SUCCESS";
export const PROFESSIONAL_REFERENCE_FAILED = "PROFESSIONAL_REFERENCE_FAILED";

export const PROF_REF_ADD_LOADING = "PROF_REF_ADD_LOADING";
export const PROF_REF_ADD_SUCCESS = "PROF_REF_ADD_SUCCESS";
export const PROF_REF_ADD_FAILED = "PROF_REF_ADD_FAILED";

export const PROF_REF_REMOVE_LOADING = "PROF_REF_REMOVE_LOADING";
export const PROF_REF_REMOVE_SUCCESS = "PROF_REF_REMOVE_SUCCESS";
export const PROF_REF_REMOVE_FAILED = "PROF_REF_REMOVE_FAILED";

export const PROF_REF_SAVE_LOADING = "PROF_REF_SAVE_LOADING";
export const PROF_REF_SAVE_SUCCESS = "PROF_REF_SAVE_SUCCESS";
export const PROF_REF_SAVE_FAILED = "PROF_REF_SAVE_FAILED";